import { fetchAsObservable } from 'fetcher!sofe'

export function rememberDevice() {
  return fetchAsObservable('/mfa-remember', {
    method: 'post'
  })
}